import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import LazyLoad from 'react-lazy-load'
import {selectAlbumPhotoList, selectSrc, selectSrcSetPrefix} from './albumSelectors'

const supportsSrcSet = 'srcset' in document.createElement('img')

export default class ThumbnailBrowser extends Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  render () {
    const {album} = this.props
    const photos = selectAlbumPhotoList(album)

    return (
      <ul className="thumbnail-browser">
        {photos.map(photo => (
          <li key={photo}>
            <LazyLoad height={145} width={145} offset={1000}>
              <Link to={`${photo}/`}>
                <FancyLoadImg album={album} photo={photo} />
              </Link>
            </LazyLoad>
          </li>
        ))}
      </ul>
    )
  }
}

class FancyLoadImg extends Component {
  constructor (props) {
    super(props)
    this.state = {loaded: false}
    this.loaded = this.loaded.bind(this)
  }

  loaded () {
    this.setState({loaded: true})
  }

  render () {
    const {album, photo} = this.props
    const {loaded} = this.state

    return (
      <img
        className={loaded ? 'loaded' : 'loading'}
        alt={photo}
        sizes="145px"
        srcSet={selectSrcSetPrefix(album, photo, 'thumb')}
        src={supportsSrcSet ? null : selectSrc(album, photo, 'thumb1x')}
        onLoad={this.loaded}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/ThumbnailBrowser.js